(function ($) {

    $.fn.showChildElement = function () {
        $(this).addClass('data-display-show');
    };

    $.fn.hideAndResetChildElement = function () {
        $(this).removeClass('data-display-show');

        // Exclusion bouton (bug infobulle)
        let field = $(this).find(':input').not(':input[type=button], :input[type=submit], :input[type=reset]');

        field.resetField();
        field.trigger('change');
    };

    $.fn.display = function () {

        return this.each(function () {

            const myDisplay = $(this);

            const isSelect = $(this).is('select');
            const isChoice = $(this).is('input[type="checkbox"], input[type="radio"]');

            $(myDisplay).bind('change', function () {

                // TODO attention risqué ! (si une chaine de caractères est contenue dans une autre)
                let childrenSelector = '[data-display-parent*=' + $(this).attr('name') + ']';

                let $children = $(childrenSelector);

                // Get value
                let val = null
                if (isSelect) {
                    val = $(this).val();
                } else if (isChoice) {
                    if ($(this).is(':checked')) {
                        val = $(this).val();
                    }
                }

                if (!val) {

                    // Boucle sur les enfants
                    $.each($children, function () {
                        $(this).hideAndResetChildElement();
                    });

                } else {

                    $.each($children, function () {

                        let condition = undefined;

                        const displayValues = $(this).data('display-values');

                        // Custom : plusieurs parents
                        if ($(this).data('display-custom')) {

                            condition = false;

                            // Exclusion bouton (bug infobulle)
                            let inputName = $(this).find(':input').not(':input[type=button], :input[type=submit], :input[type=reset]').attr('name');

                            if (inputName === 'reserviste') {
                                if ($('#activite_AUT').is(':checked')) {
                                    condition = true;
                                } else if ($('#activite_INA').is(':checked') && ['AUT', 'ETU', 'SAN'].includes($('#categorieInactif').val())) {
                                    condition = true;
                                }
                            }

                            if (inputName === 'doubleEffet') {

                                const valueNbEnfants = $('select[name="nbEnfants"]').val();

                                let conditionA = false;
                                let conditionB = false;

                                if (valueNbEnfants && parseInt(valueNbEnfants) > 0) {
                                    conditionA = true;
                                }

                                const valueSituationFamiliale = $('input[name="situationFamiliale"]:checked').val();
                                if (valueSituationFamiliale && ['MAR', 'PAC'].includes(valueSituationFamiliale)) {
                                    conditionB = true;
                                }

                                condition = (conditionA && conditionB);
                            }

                        } else if (isSelect) {
                            // Si la value selected figure parmi les display-values de l'enfant alors visible sinon hidden
                            for (let i in displayValues) {
                                if (displayValues[i] === val) {
                                    condition = true;
                                }
                            }
                        } else if (isChoice) {
                            // Si la value checked figure parmi les display-values de l'enfant alors show sinon hide
                            // TODO : gérer displayValues undefined !
                            condition = displayValues.includes(val);
                        }

                        (condition) ? $(this).showChildElement() : $(this).hideAndResetChildElement();
                    });
                }
            });
            return myDisplay;
        });
    };

    $('[data-display-show="true"]').addClass('data-display-show')
    $('.agpm-cascading-display').display();

}(jQuery));
